import React from "react";
import { Card } from "react-bootstrap";
import Chart from "react-apexcharts";
import { GraphCardsHeader } from "@ui";

function TreeMapChart({ series, title, height = 300 }) {
  let chartOptions = {
    series: [
      {
        data: series || [],
      },
    ],
    options: {
      colors: ["#3256B8"],
      fill: {
        opacity: 1,
      },
      legend: {
        show: false,
      },
      chart: {
        height: 350,
        type: "treemap",

        toolbar: {
          show: false,
        },
      },
      toolbar: {
        show: false,
      },
      yaxis: {
        labels: {
          formatter: function (value) {
            return value + "%";
          },
        },
      },
    },
  };

  function exportCSV() {
    if (!series || !series.length) return;
    const headers = [title, "Value(%)"];
    let csvContent = headers.join(",") + "\n";
    series.forEach((item) => {
      csvContent += `${item.x},${item.y}\n`;
    });
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    if (link.download !== undefined) {
      const url = URL.createObjectURL(blob);
      link.setAttribute("href", url);
      link.setAttribute("download", `${title}_data.csv`);
      link.style.visibility = "hidden";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }

  return (
    <Card className="h-100 m-0">
      <GraphCardsHeader
        title={title}
        showDownloadButtons={true}
        needCSVDownload={true}
        downloadCSV={exportCSV}
      />
      <Card.Body className="p-4 py-2">
        <div id="chart">
          <Chart
            options={chartOptions.options}
            series={chartOptions.series}
            type="treemap"
            height={height}
          />
        </div>
      </Card.Body>
    </Card>
  );
}

export default TreeMapChart;
